<template>
    <el-dialog
        :visible.sync="dialogVisible"
        :title="modalData.title"
        :close-on-press-escape="false"
        width="500px"
        append-to-body
        :before-close="handleClose">
        <el-form ref="dataForm" class="account-form" :model="formItem" :rules="rules"
                 @keyup.enter.native="handleSubmit" label-width="0">

            <el-form-item prop="username">
                <el-input placeholder="请输入账号" id="username" v-model.trim="formItem.username">
                    <template slot="prepend">账号：</template>
                </el-input>
            </el-form-item>
            <el-form-item prop="password">
                <el-input placeholder="请输入密码" id="password" v-model.trim="formItem.password"
                          show-password>
                    <template slot="prepend">密码：</template>
                </el-input>
            </el-form-item>
            <el-form-item prop="verify" class="label-required captcha-wrap">
                <div id="geeTest">
                    <!--<p class="tac pt10 font12px">正在加载验证码...</p>-->
                </div>
            </el-form-item>
            <el-form-item class="tac">
                <el-button type="default" @click="hideModal" class="action-btn mr20">取消</el-button>
                <el-button type="primary" @click="handleSubmit" :loading="submitLoading" class="action-btn ml20">保存
                </el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>
    export default {
        name: "PlatAccountModal",
        props: {
            modalData: {
                type: Object,
                required: true,
            },
        },
        data(){
            return {
                dialogVisible:false,
                submitLoading:false,
                formItem:{
                    username:'',
                    password:'',
                    verify:'',
                },
                rules:{

                },
            }
        },
        methods:{
            handleClose() {
                this.dialogVisible = false;
                this.resetForm();
            },
            resetForm() {
                console.log('resetForm');
            },
            hideModal(){
                this.handleClose();
                this.$emit('close',this.modalData);
            },
            showModal() {
                this.dialogVisible = true;
            },
            handleSubmit() {
                this.$emit('save-value',this.modalData);
                this.handleClose();
            },
        },
    }
</script>

<style lang="scss" scoped>
    .account-form{
        margin: 0 60px;
    }
    .captcha-wrap{
        height: 32px;
        line-height: 32px;
        background-color: #f8f8f9;
        border: solid 1px #dcdee2;
        border-radius: 5px;
    }
</style>
